export interface AssessmentInfo {
    shortName: string;
    fullName: string;
    reportDescription: Html;
    entryReference?: Html;
}

export type Html = string;

export enum Icf {
    Level0,
    Level1,
    Level2,
    Level3,
    Level4,
}

export type IcfCategory
    = "b760"
    | "d410"
    | "d4101"
    | "d4102"
    | "d4103"
    | "d4104"
    | "d4105"
    | "d4106"
    | "d4153"
    | "d4154"
    | "d420"
    | "d430"
    | "d440"
    | "d4400"
    | "d445"
    | "d450"
    | "d4500"
    | "d4502"
    | "d455"
    | "d4551"
